import { DescriptionProps, IDescription } from './types';

export const mapDescription = ({
  prismicContent,
}: {
  prismicContent: DescriptionProps['slice'];
}): IDescription => {
  return { description: prismicContent.primary.description };
};
